













































import Component, { mixins } from 'vue-class-component'
import SearchInput from '@/components/inputs/SearchInput.vue'
import ScrollView from '@/components/ScrollView.vue'
import Checkbox from '@/components/inputsV2/Checkbox.vue'
import { AgingFilterFormsMixin } from '@/views/app/management/collections/components/GlobalAging/AgingFilterFormsMixin'
import { Debounce } from 'vue-debounce-decorator'
import { FacilityModule } from '@/store/modules/facility.module'
import { getModule } from 'vuex-module-decorators'
import { IFacility } from '@zunta/configurations'
import LoaderWrapper from '@/components/layout/LoaderWrapper.vue'

@Component({
  components: { LoaderWrapper, Checkbox, ScrollView, SearchInput }
})
export default class FacilityFilterForm extends mixins(AgingFilterFormsMixin) {
  facilityModuleInstance: FacilityModule = getModule(FacilityModule, this.$store)
  localOptions: any = {}

  get selectedFacilities () {
    return this.filtersMap['facilities']
  }

  @Debounce(800)
  async fetchData () {
    if (!this.searchValue) {
      return
    }

    try {
      this.isLoading = true
      const res = await this.facilityModuleInstance.getFacilityListAndReturn({
        name: this.searchValue
      })
      const optionMap: any = {}
      res.forEach((facility: IFacility) => {
        if (facility.id) {
          optionMap[facility.id] = {
            value: facility.id,
            label: facility.name
          }
        }
      })
      this.localOptions = optionMap
    } finally {
      this.isLoading = false
      if (this.focusEl) {
        setTimeout(() => this.focusEl.focus(), 50)
      }
    }
  }
}
